function StepRail({ steps, current }) {
  return (
    <ol className="step-rail">
      {steps.map((s) => {
        const state =
          s.n < current ? "done" : s.n === current ? "current" : "upcoming";

        return (
          <li key={s.n} className={`step-rail-item step-rail-item--${state}`}>
            <span className="step-rail-marker">
              {String(s.n).padStart(2, "0")}
            </span>
            <span className="step-rail-label">{s.label}</span>
          </li>
        );
      })}
    </ol>
  );
}

export default StepRail;